import { render, staticRenderFns } from "./CopyToRegister.vue?vue&type=template&id=4c2d3600&scoped=true"
import script from "./CopyToRegister.vue?vue&type=script&lang=js"
export * from "./CopyToRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2d3600",
  null
  
)

export default component.exports